<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import DwHeader from "@/components/layouts/DwHeader.vue";
import DwHeaderLogin from "@/components/layouts/DwHeaderLogin.vue";
import DwNavMenu from "@/components/layouts/DwNavMenu.vue";

export default {
  name: "App",
  components: {
    "dw-nav-menu": DwNavMenu,
    "dw-header": DwHeader,
    "dw-header-login": DwHeaderLogin,
  },
  data() {
    return {
      currentHeader: "dw-header",
    };
  },
  mounted() {
    const urlToken = this.$route.query.Authorization
    const localToken = localStorage.getItem("Authorization")
    // 先写入 token（原逻辑 reload 在前会导致 setItem 永不执行，token 丢失）
    if (urlToken) {
      localStorage.setItem("Authorization", urlToken)
    }
    // token 变化时刷新一次，让请求拦截器用上新 token
    if (urlToken && urlToken !== localToken) {
      location.reload()
    }

    // window.addEventListener("message", (event) => {
    //   let data = event.data;
    //   switch (data.iframeClick) {
    //     case "getParams":
    //       if (data.params.key == "xiaohui") {
    //         localStorage.clear();
    //       }
    //   }
    // });
  },
  methods: {
    loginStatus: function () {
      const fullPath = this.$route.fullPath;
      if (fullPath.indexOf("login") >= 0) {
        this.currentHeader = "dw-header-login";
      } else {
        this.currentHeader = "dw-header";
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue